<script lang="ts">
  import { onMount } from 'svelte';

  import slugify from 'slugify';

  import { keyboardLayout } from '$stores/useKeyboardLayout';

  import BindConfig from '$components/BindConfig/BindConfig.svelte';
  import Card from '$components/Card/Card.svelte';
  import CommandExample from '$components/CommandExample/CommandExample.svelte';
  import Ips from '$components/IPS/IPS.svelte';
  import Jumbo from '$components/Jumbo/Jumbo.svelte';

  import type { PageData } from './$types';

  export let data: PageData;
  let { pageData, data: templateData } = data;
  $: ({ pageData, data: templateData } = data);

  const isMultiCommand = templateData.bind.command.commands.length > 1;

  onMount(() => {
    if (templateData.scancodeConfig.autoDetectKeys) keyboardLayout.detectUserMap();
  });
</script>

<Jumbo
  config={{
    title: templateData.bind.name,
    text: templateData.bind.description,
    icon: templateData.bind.icon,
  }}
  showIps={isMultiCommand}
/>

<div class="rw">
  <div class="cl cl-{isMultiCommand ? 10 : 5} cl-gap break-m">
    <Card
      modifiers={['gap']}
      config={{
        title: 'Bind Commands',
        headingNum: 'h2',
        icon: 'code',
        content: templateData.bind.pageDescription,
      }}
      solidHeading
      padding
    >
      {#if templateData.bind.command}
        <BindConfig
          slug={templateData.bind.slug}
          command={templateData.bind.command}
          showHelp
          hideVersion={isMultiCommand}
          config={templateData.scancodeConfig}
          smallSpace
          cunModal={{ referenceUrl: `/binds/${templateData.bind.slug}` }}
        />
      {/if}
    </Card>
    {#if templateData.bind.variations.length}
      <Card
        modifiers={['gap']}
        config={{
          title: 'How it Works',
          headingNum: 'h2',
          icon: 'graduation-cap',
          content: templateData.bind.howItWorks,
        }}
        solidHeading
        padding
      />
    {/if}
  </div>
  <div class="cl cl-{isMultiCommand ? 10 : 5} cl-gap break-m">
    {#if !isMultiCommand}
      <Ips />
    {/if}
    {#if templateData.bind.variations.length}
      <Card
        config={{
          title: 'Other Bind Variations',
          headingNum: 'h2',
          icon: 'vial',
        }}
        solidHeading
      >
        <p class="u-padding">Find different variations of this bind below.</p>
        <ul class="variations normalize">
          {#each templateData.bind.variations as variation}
            <CommandExample
              scancodeConfig={templateData.scancodeConfig}
              config={variation}
              slug={slugify(variation.name, { lower: true, strict: true })}
              referenceUrl="/binds/{templateData.bind.slug}"
            />
          {/each}
        </ul>
      </Card>
    {:else}
      <Card
        modifiers={['gap']}
        config={{
          title: 'How it Works',
          headingNum: 'h2',
          icon: 'graduation-cap',
          content: templateData.bind.howItWorks,
        }}
        solidHeading
        padding
      />
    {/if}
  </div>
</div>

<style lang="scss">
  .card-text {
    color: $col-light-3;
    font-size: 1.3rem;
  }

  .variations {
    display: flex;
    flex-direction: column;
    // background-color: rgba(255, 255, 255, 0.05);
  }
</style>
